export default function getProgramCodeToNameMap(programSelector) {
  const { programs = [] } = programSelector;
  const shortCodeToProgram = new Map();
  for (const program of programs) {
    shortCodeToProgram.set(program.short_name, program.program);
  }
  return shortCodeToProgram;
}
